import { EClusterPinAnchor } from '../../../constants/clusterPins/types';

// Горизонтальное смещение прямоугольника-формы балуна относительно гео-точки фичи под его anchor.
// Должно быть синхронно с CSS-трансформом .pin[data-anchor] в styles.css:
//   left   -> левый край на гео-точке   (translateX(0),     offsetX = 0)
//   right  -> правый край на гео-точке   (translateX(-100%), offsetX = -width)
//   center -> центр на гео-точке         (translateX(-50%),  offsetX = -width / 2)
// width — РЕАЛЬНАЯ ширина отрисованного балуна (зависит от цены/иконки): фиксируется
// именно край/центр, а пилюля растёт от реальной ширины внутрь — контур ромашки не плывёт.
export function getBalloonShapeOffsetX(anchor: EClusterPinAnchor, width: number): number {
  if (anchor === EClusterPinAnchor.Left) {
    return 0;
  }

  if (anchor === EClusterPinAnchor.Right) {
    return -width;
  }

  return -width / 2;
}

// Смещение визуального ЦЕНТРА пилюли от её гео-точки (точки привязки) по X.
// Нужно, чтобы превью оффера центрировалось под пилюлей независимо от её anchor:
//   left   -> гео-точка = левый край,  центр правее на width/2
//   center -> гео-точка = центр,        смещения нет (0)
//   right  -> гео-точка = правый край,  центр левее на width/2
export function getPinCenterOffsetX(anchor: EClusterPinAnchor, width: number): number {
  return getBalloonShapeOffsetX(anchor, width) + width / 2;
}
